<template>
  <div class="w-full flex py-2">

    <div class="flex flex-col flex-grow">
      <div class="flex flex-grow border-b border-trader-dark-gray"></div>
      <div class="flex flex-grow border-t-2 border-white dark:border-trader-gray"></div>
    </div>

  </div>
</template>

<script>
export default {
  meta: {
    name: "Trenner",
    type: "fieldtype",
    version: "1.0.0",
    hasOptions: false,
    hideLabel: true,
  },
  props: {
    name: "Trenner",
    formField: {
      type: Object,
      default: () => {
      }
    },
    productData: {
      type: Object,
      default: () => {
      }
    },
    onChangeProductFieldValue: {
      type: Function,
      default: () => {
      }
    },
    getFieldValue: {
      type: Function,
      default: () => {
      }
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  methods: {}
}
</script>


